import { ApiSchema } from "@api-types";
import { useObservable } from "@rsm";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getClientService } from "services/client.service";
import { useIsChurned } from "hooks/useIsChurned";
import { useChurnTransactionsPath } from "hooks/useChurnTransactionsPath";

export const useHomePageRedirect = (dontRedirectForTier?: ApiSchema.ClientTierLookup) => {
  const { clientId } = useParams<{ clientId?: string }>();
  useEffect(() => {
    clientId && !isNaN(Number(clientId)) && getClientService().changeClientId(Number(clientId));
  }, [clientId]);
  const defaultClientId = useObservable(getClientService().defaultClientId$);
  const currentClient = useObservable(getClientService().client$);
  const { isRestricted, isIdeallyAdmin } = useIsChurned();
  const churnTransactionsPath = useChurnTransactionsPath();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      window.location.pathname !== `/${defaultClientId}` &&
      window.location.pathname !== `/${defaultClientId}/` &&
      clientId &&
      (Number(clientId) !== defaultClientId ||
        !currentClient?.tier ||
        dontRedirectForTier === currentClient?.tier)
    ) {
      return;
    }
    // Restricted (churned) non-admins land on transactions when reachable; otherwise fall through to
    // the default target, where the route gate shows the inactive landing page.
    if (isRestricted && !isIdeallyAdmin) {
      if (churnTransactionsPath === undefined) return;
      if (churnTransactionsPath) {
        navigate(churnTransactionsPath, { replace: true });
        return;
      }
    }
    if (currentClient?.tier === "Team") {
      navigate(`/${currentClient.id}/home`, { replace: true });
    } else if (currentClient) {
      navigate(`/${currentClient.id}/manage-${currentClient.tier.toLocaleLowerCase()}`, { replace: true });
    } else if (defaultClientId && !clientId) {
      navigate(`/${defaultClientId}`, { replace: true });
    }
  }, [
    clientId,
    dontRedirectForTier,
    currentClient,
    defaultClientId,
    navigate,
    isRestricted,
    isIdeallyAdmin,
    churnTransactionsPath,
  ]);
};
